import React, { useContext } from 'react';
import { I18nReactContext } from '../../../../../contexts/I18nContext';
import { CompanyReactContext } from '../../../../../contexts/CompanyContext';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import ImageIcon from '@mui/icons-material/Image';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import CategoryIcon from '@mui/icons-material/Category';
import QuizIcon from '@mui/icons-material/Quiz';
import Tooltip from '@mui/material/Tooltip';
import './ChapterEditor.scss';
import './ComponentBank.scss';

export const ComponentBank = ({ onAddComponent }) => {
    const { i18n, isRtl } = useContext(I18nReactContext);
    const { companyLogoUrl } = useContext(CompanyReactContext);

    // Check if logo exists
    const logoExists = !!companyLogoUrl && companyLogoUrl !== '';

    // List of available component types
    const componentTypes = [
        {
            type: 'text',
            name: i18n.translate('weezbeeCourse.editor.componentBank.text.name', { defaultValue: 'Text' }),
            description: i18n.translate('weezbeeCourse.editor.componentBank.text.description', { defaultValue: 'Simple text component' }),
            icon: <TextFieldsIcon />
        },
        {
            type: 'bullets',
            name: i18n.translate('weezbeeCourse.editor.componentBank.bullets.name', { defaultValue: 'Bullets' }),
            description: i18n.translate('weezbeeCourse.editor.componentBank.bullets.description', { defaultValue: 'Bullet list component' }),
            icon: <FormatListBulletedIcon />
        },
        {
            type: 'logo',
            name: i18n.translate('weezbeeCourse.editor.componentBank.logo.name', { defaultValue: 'Logo' }),
            description: i18n.translate('weezbeeCourse.editor.componentBank.logo.description', { defaultValue: 'Company logo component' }),
            icon: <ImageIcon />,
            disabled: !logoExists,
            tooltip: !logoExists ? i18n.translate('weezbeeCourse.editor.componentBank.logo.missingLogo', { defaultValue: 'Company logo is missing' }) : ''
        },
        {
            type: 'image',
            name: i18n.translate('weezbeeCourse.editor.componentBank.image.name', { defaultValue: 'Image' }),
            description: i18n.translate('weezbeeCourse.editor.componentBank.image.description', { defaultValue: 'Image component' }),
            icon: <ImageIcon />
        },
        {
            type: 'video',
            name: i18n.translate('weezbeeCourse.editor.componentBank.video.name', { defaultValue: 'Video' }),
            description: i18n.translate('weezbeeCourse.editor.componentBank.video.description', { defaultValue: 'Video component' }),
            icon: <VideoLibraryIcon />
        },
        {
            type: 'shape',
            name: i18n.translate('weezbeeCourse.editor.componentBank.shape.name', { defaultValue: 'Shape' }),
            description: i18n.translate('weezbeeCourse.editor.componentBank.shape.description', { defaultValue: 'Basic shapes component' }),
            icon: <CategoryIcon />
        },
        {
            type: 'question',
            name: i18n.translate('weezbeeCourse.editor.componentBank.question.name', { defaultValue: 'Question' }),
            description: i18n.translate('weezbeeCourse.editor.componentBank.question.description', { defaultValue: 'Interactive question component' }),
            icon: <QuizIcon />
        }
        // Add more component types here as needed
    ];

    return (
        <div
            className="ComponentBank ComponentBank--rail"
            role="toolbar"
            aria-label={i18n.translate('weezbeeCourse.editor.componentBank.title', { defaultValue: 'Component Bank' })}
        >
            <div className="bank-component-list" aria-label={i18n.translate('weezbeeCourse.editor.componentBank.description', { defaultValue: 'Click to add components' })}>
                {componentTypes.map(component => (
                    <Tooltip key={component.type} title={component.name} placement={isRtl ? 'right' : 'left'} arrow>
                        <button
                            type="button"
                            className={`bank-component-item ${component.disabled ? 'disabled' : ''}`}
                            onClick={() => !component.disabled && onAddComponent(component.type)}
                            aria-label={component.name}
                            disabled={!!component.disabled}
                        >
                            <span className="component-icon" aria-hidden="true">{component.icon}</span>
                        </button>
                    </Tooltip>
                ))}
            </div>
        </div>
    );
};
